<template>
  <div class="memberCenter_wrap EnterpriseInform">
    <div class="nav_pos mb_nav_pos">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>招标/比选管理</el-breadcrumb-item>
        <el-breadcrumb-item>上传投标确认函</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content_wrap">
      <div class="change_inform">
        <div class="title">项目信息</div>
        <el-form :inline="true" :model="PurchaseScheme" class="form_table">
          <el-form-item label="采购编号">{{ PurchaseScheme.SchemeCode }}</el-form-item>
          <el-form-item label="项目名称">{{ PurchaseScheme.ProjectName }}</el-form-item>
          <el-form-item label="投标确认截止时间">{{ PurchaseScheme.TenderConfirmDate }}</el-form-item>
          <el-form-item label="投标截止时间">{{ PurchaseScheme.BiddingDeadline }}</el-form-item>
          <el-form-item label="开标时间">{{ PurchaseScheme.BidOpeningDate }}</el-form-item>
          <el-form-item label="招标文件">
            {{ PurchaseScheme.BiddingFileName }}
            <el-button class="btn" @click.stop="fnDownload(PurchaseScheme.BiddingFileId, PurchaseScheme.BiddingFileName)">下载</el-button>
          </el-form-item>
          <el-form-item v-if="PurchaseScheme.Reason != null && PurchaseScheme.Reason != ''" label="确认函退回原因">{{ PurchaseScheme.Reason }}</el-form-item>
        </el-form>
      </div>
      <div class="change_inform">
        <div class="title">招标内容</div>
        <div v-for="(item, index) in TechnicalTransformGroup" :key="index" style="margin: 15px 0">
          <div class="title1">
            <span>包组：{{ item.GroupName }}</span>
          </div>
          <div>
            <el-table class="table_wrap1 table1" :data="item.TechnicalTransformList" border>
              <el-table-column prop="Index" label="序号" width="100"></el-table-column>
              <el-table-column prop="InstrumentName" label="设备名称"></el-table-column>
              <!-- <el-table-column prop="Specification" label="设备型号"></el-table-column> -->
              <el-table-column prop="Count" label="数量（套）" width="140"></el-table-column>
              <!-- <el-table-column prop="Remark" label="备注"></el-table-column> -->
            </el-table>
          </div>
        </div>
      </div>
      <div class="change_inform">
        <div class="title">报名信息</div>
        <el-form :inline="true" :inline-message="true" :model="AcceptInvitation" :rules="rules" ref="AcceptInvitation" class="form_table">
          <el-form-item label="投标单位名称">{{ AcceptInvitation.SupplierName }}</el-form-item>
          <el-form-item label="联系人" prop="ProjectLeader">
            <el-input v-model="AcceptInvitation.ProjectLeader" type="text"></el-input>
          </el-form-item>
          <el-form-item label="联系人手机" prop="Mobile">
            <el-input v-model="AcceptInvitation.Mobile" type="text"></el-input>
          </el-form-item>
          <el-form-item label="电子邮箱" prop="Email">
            <el-input v-model="AcceptInvitation.Email" type="text"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="change_inform">
        <div class="title">投标确认函</div>
        <el-form :inline="true" ref="AcceptInvitation2" :model="AcceptInvitation" :rules="rules" class="form_table">
          <el-form-item prop="FileList" label="投标确认函">
            <el-upload
              action="/Purchase/UploadClarifyFile"
              :on-success="handleSuccess"
              :auto-upload="true"
              :before-upload="beforeUpload"
              :limit="1"
              :before-remove="beforeRemove"
              :on-remove="handleRemove"
              :on-exceed="handleExceed"
              :file-list="AcceptInvitation.FileList"
              :on-preview="handleDownLoad"
              :http-request="uploadSectionFile"
              accept=".pdf"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
          <div class="btn_wrap2">
            <el-button class="btn2" @click="fnDownload(TemplateFileId, '投标确认模板')">下载投标确认模板</el-button>
          </div>
        </el-form>
      </div>
      <div class="btn_wrap">
        <span class="btn_1 btn_reg" @click.stop="RefuseEvents">拒绝邀请</span>
        <span class="btn_1" @click.stop="AcceptEvents">接收邀请</span>
      </div>
    </div>
  </div>
</template>

<script>
import { validateEmail, validatemobile1 } from '@/assets/js/util'
export default {
  data() {
    return {
      rules: {
        FileList: [{ required: true, message: '请上传文件', trigger: 'change' }],
        ProjectLeader: [{ required: true, message: '请填写联系人', trigger: 'blur' }],
        Mobile: [
          {
            required: true,
            message: '请填写正确的联系方式',
            validator: validatemobile1,
            trigger: 'blur'
          }
        ],
        Email: [
          {
            required: true,
            validator: validateEmail,
            message: '请填写正确的邮箱',
            trigger: 'blur'
          }
        ]
      },
      FileList: [],
      AcceptInvitation: { FileList: [] },
      TechnicalTransforList: [],
      TechnicalTransformGroup: [],
      activeName: 'first',
      formInline: {},
      qualificationList: [],
      enclosureList: [],
      type: '',
      PurchaseScheme: {}
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    beforeUpload(file) {
      if (file.type != 'application/pdf') {
        this.$message.warning('只能上传PDF文件!')
        return false
      } else {
        return true
      }
    },
    beforeRemove(file) {
      window.console.log(file)
      let isDelete = true
      if (file && file.status === 'success') {
        isDelete = this.$confirm(`确定删除 ${file.name}？`)
      }
      return isDelete
    },
    handleRemove(file) {
      if (file && file.status === 'success') {
        this.AcceptInvitation.FileList = this.AcceptInvitation.FileList.filter(function (item) {
          return item.id != file.id
        })
      }
    },
    uploadSectionFile(params) {
      const file = params.file
      var data = new window.FormData()
      data.append('file', file)
      data.append('loginToken', window.localStorage.getItem('loginToken'))
      this.uploadFileRequest('Purchase/UploadFile', data).then((res) => {
        if (res.data.errcode == 0) {
          this.AcceptInvitation.FileList = res.data.FileList
        }
      })
    },
    handleDownLoad() {
      window.console.log(this.AcceptInvitation.FileList[0].fileId)
      let token = window.localStorage.getItem('loginToken')
      var url = 'Purchase/DownloadFile?fileId=' + this.AcceptInvitation.FileList[0].id + '&token=' + token

      this.downloadfile(this.baseURL + url)
    },
    handleExceed(files, fileList) {
      this.$message.warning('只能选择1个文件!')
    },
    handleSuccess(response) {
      var fileList = [
        {
          fileId: response.fileId,
          fileName: response.fileName,
          id: response.fileId,
          name: response.fileName
        }
      ]
      this.AcceptInvitation.FileList = fileList
      window.console.log(this.AcceptInvitation.FileList)
    },
    fnDownload(fileId, fileName) {
      let token = window.localStorage.getItem('loginToken')
      var url = 'Purchase/DownloadFile?FileId=' + fileId + '&token=' + token

      this.downloadfile(this.baseURL + url)
    },
    AcceptEvents() {
      this.$refs.AcceptInvitation2.validate((valid2) => {
        if (valid2) {
          this.$refs.AcceptInvitation.validate((valid) => {
            if (valid) {
              let config = {
                params: {
                  id: this.$route.query.id,
                  IsAccept: true,
                  AcceptInvitation: JSON.stringify(this.AcceptInvitation)
                }
              }
              // if (
              //   this.AcceptInvitation.FileList == undefined ||
              //   this.AcceptInvitation.FileList == null
              // ) {
              //   this.$message.error("请上传投标确认函");
              //   return;
              // }
              this.getRequest('/Purchase/SaveInvitation', config)
                .then((res) => {
                  var data = res.data
                  if (data.errcode == 0) {
                    this.$message.success('成功接受邀请!')
                    localStorage.setItem('InvitationList', Math.random()) //刷新父页面
                    setTimeout(() => {
                      window.close()
                    }, 1000)
                  } else {
                    this.$message.error(data.errmsg)
                  }
                })
                .catch(function (error) {
                  console.log(error)
                })
            }
          })
        }
      })
    },
    RefuseEvents() {
      this.$confirm('是否确认拒绝该邀请', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let config = {
          params: {
            id: this.$route.query.id,
            IsAccept: false
          }
        }
        this.getRequest('/Purchase/SaveInvitation', config)
          .then((res) => {
            var data = res.data
            if (data.errcode == 0) {
              this.$message.success('已拒绝邀请!')
              localStorage.setItem('InvitationList', Math.random()) //刷新父页面
              setTimeout(() => {
                window.close()
              }, 1000)
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      })
    },
    back() {
      this.$router.push('/InvitationList')
    },
    getList() {
      let config = {
        params: {
          id: this.$route.query.id
        }
      }
      this.getRequest('/Purchase/GetInvitationDetail', config)
        .then((res) => {
          var data = res.data
          if (res.data.errcode == 0) {
            this.TechnicalTransforList = res.data.TechnicalTransforList
            this.PurchaseScheme = res.data.PurchaseScheme
            this.AcceptInvitation = res.data.AcceptInvitation
            this.TemplateFileId = res.data.TemplateFileId
            this.TemplateFileName = res.data.TemplateFileName
            this.TechnicalTransformGroup = res.data.TechnicalTransformGroup
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    download(FileId, remark, fileName) {
      let token = window.localStorage.getItem('loginToken')
      token = token.replace(/\+/g, '%2B')
      var url = 'SupplierLogin/DownLoadFile?fileId=' + FileId + '&remark=' + remark + '&token=' + token + '&fileName=' + fileName
      console.log(this.baseURL + url)
      this.downloadfile(this.baseURL + url)
    }
  }
}
</script>
<style lang="scss" scoped>
.mb_nav_pos {
  padding: 5px 0 0;
}
.change_inform {
  .title {
    height: 34px !important;
    line-height: 40px !important;
    border-bottom: 1px solid #95c7f0 !important;
    margin-bottom: 13px;
    padding-top: 15px !important;
  }
  .el-table--border {
    border-bottom: 1px solid #95c7f0 !important;
  }
  ::v-deep .table_wrap1 {
    table {
      margin: 0;
      td,
      tr,
      th {
        border-color: #95c7f0;
      }
      th {
        border-top: 1px solid #95c7f0;
        background-color: #d8eafa;
      }
    }
  }
}

.btn_wrap {
  width: 360px;
  height: 40px;
  text-align: center;
  padding: 10px;
  margin: auto;
}
.btn2 {
  color: #6a96bc;
  border: 1px solid #6a96bc;
  border-radius: 15px;
  padding: 0px 15px;
  margin: 5px 23px;
  height: 24px;
}
.btn {
  color: #6a96bc;
  border: 1px solid #6a96bc;
  border-radius: 8px;
  padding: 0px 15px;
  margin: 5px 23px;
  height: 24px;
}
.EnterpriseInform {
  .content_wrap {
    // padding-top: 15px;
    padding-bottom: 50px;
    margin-bottom: 20px;
  }
  ::v-deep .el-form {
    margin: 0 15px 5px;
    .el-form-item__content {
      justify-content: left;
    }
  }
  .title {
    height: 50px;
    line-height: 50px;
    border: none;
  }
  .record_table {
    margin-top: 0;
  }
  .link {
    cursor: pointer;
  }
}
.filelist {
  margin-bottom: 10px;
}
.btn_wrap2 {
  height: 40px;
  text-align: left;
  padding: 10px;
  margin: auto 30px;
  .btn_1 {
    color: #0099ff;
    background: #fafafa;
    height: 30px;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    line-height: 40px;
    display: inline-block;
    border: 1px solid #2db7f5;
    text-align: center;
    border-radius: 23px;
    color: #0099ff;
    background: #fafafa;
    cursor: pointer;
  }
}
.table1 {
  width: 98%;
  margin: 0 1%;
}
.title1 {
  margin: 0 0 5px 2%;
  font-size: 15px;
  font-weight: 600;
}
</style>
